import invariant from 'invariant';

import { MainChartData } from 'modules/salaries/types/MainChartData';

export function getMainChartActiveLayer(data: MainChartData) {
  invariant(data, 'chart data is required to get active layer');

  if (data.barChart && data.barChart.active) {
    return 'submissions';
  }

  return 'estimatedRange';
}
